import { bootstrapAppState } from './app-state.js';

bootstrapAppState();
